import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";

import {Option} from "@models/select-dropdown-option.interface";
import {FontAwesomeService} from "@services/font-awesome.service";

@Component({
  selector: 'app-autocomplete-field',
  template: `
    <ng-container [formGroup]="parent">
      <fa-icon *ngIf="leadingIcon"
               (click)="handleClick($event)"
               class="leading-icon"
               [icon]="faService[leadingIcon]"></fa-icon>
      <fa-icon *ngIf="trailingIcon"
               (click)="handleClick($event)"
               class="trailing-icon"
               [icon]="faService[trailingIcon]"></fa-icon>
      <input
        type="text" matInput
        #input
        [formControlName]="controlName"
        [matAutocomplete]="auto"
        [ngStyle]="inputStyles"
        animateInput
        [error]="error"
        [inputValue]="parent.get(controlName).value"
        [label]="labelRef"
        [leadingIcon]="leadingIcon">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="handleSelect($event)">
        <mat-option *ngFor="let option of options" [value]="option.label">
          {{option.label}}
        </mat-option>
      </mat-autocomplete>
      <label #labelRef [ngClass]="classes" (click)="handleClick($event)">{{label}}</label>
    </ng-container>
  `,
  styleUrls: ['../common.scss', './autocomplete-field.component.scss']
})
export class AutocompleteFieldComponent {
  @Input() label: string;
  @Input() leadingIcon: string;
  @Input() trailingIcon: string;
  @Input() parent: FormGroup;
  @Input() controlName: string;
  @Input() submitted: boolean;
  @Input() options: Array<Option>;
  @Input() error: boolean;

  @Output() changeOption: EventEmitter<any> = new EventEmitter();
  @ViewChild('input') input: ElementRef;

  constructor(public faService: FontAwesomeService) {}

  handleSelect(event) {
    const selectedLabel = event.option.value;
    const selectedOption = this.options.find(({label}) => label === selectedLabel);
    if (selectedOption) {
      this.changeOption.emit(selectedOption);
      this.parent.get(this.controlName).setValue(selectedLabel);
    }
  }
  get classes() {
    let classes = '';
    if (this.leadingIcon) {
      classes += 'leading-icon ';
    }
    return classes;
  }
  get inputStyles() {
    return this.leadingIcon ? {paddingLeft: '34px'} : {};
  }

  handleClick(e) {
    this.input.nativeElement.focus();
    e.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/autocomplete-field/autocomplete-field.component.ts